/** @jsxImportSource @emotion/react */
import insightImage from 'static/images/insight.png';
import coverageImage from 'static/images/coverage.png';
import QueryImage from 'static/images/query.png';
import daftImage from 'static/images/draft.png';

import {
  Section,
  Container,
  Grid,
  Heading,
  SubHeading,
  Paragraph,
  FeaturesV2
} from './styles/Features.styles';

export default function Featuresv2() {
  return (
    <FeaturesV2>
      <Section>
        <Container>
          <Grid>
            <div className="content-grid">
              <Heading>
                From <span>Inbox to Insight</span>, in Seconds
              </Heading>
              <Paragraph>
                Go beyond traditional script and book coverage with modern features like automated
                character breakdowns with visual references, Performance-backed comps, and writer 
                insights.
              </Paragraph>
            </div>
            <div className="img-grid">
              <img src={insightImage} alt="Inbox to Insight" />
            </div>
          </Grid>
        </Container>
      </Section>

      <Section>
        <Container>
          <Grid colReverse>
            <div className="img-grid">
              <img src={coverageImage} alt="Two professionals collaborating" />
            </div>
            <div className="content-grid">
              <SubHeading>
                Collaborative <span>Coverage</span> Library
              </SubHeading>
              <Paragraph>
                Build your team’s coverage library automatically, with each team members’ uploads
                being logged in your company specific database, complete with Loglines, Writer info,
                and Genre. Set access levels for material on a per-entry basis, giving you control
                over sensitive material.
              </Paragraph>
            </div>
          </Grid>
        </Container>
      </Section>

      <Section>
        <Container>
          <Grid>
            <div className="content-grid">
              <SubHeading>Query</SubHeading>
              <Paragraph>
                Chat directly with full-length screenplays and books — yes, even 1,000+ pages. Ask
                anything, from deep character insights to pinpoint scene details.
              </Paragraph>
            </div>
            <div className="img-grid">
              <img src={QueryImage} alt="" />
            </div>
          </Grid>
        </Container>
      </Section>

      <Section>
        <Container>
          <Grid colReverse>
            <div className="img-grid">
              <img src={daftImage} alt="Draft Comparison" />
            </div>
            <div className="content-grid">
              <SubHeading>
                Draft <span>Comparison</span>
              </SubHeading>
              <Paragraph>
                Compare two screenplay drafts in minutes, including high-level story and character
                changes as well as page-by-page changes to dialogue, locations, and more.
              </Paragraph>
            </div>
          </Grid>
        </Container>
      </Section>
    </FeaturesV2>
  );
}
